import axios from '../plugins/axios';
const ls = require('local-storage');
let usuario = ls.get('nomeUsuario');
import store from '../store';

class impressaoUtilitario {
    getConfig() {      
        if (window.location.host.includes('192.168.18.15') || window.location.host.includes('192.168.18.16')) {
            return { logo: 'ilhaverdade.jpg', descricao: 'Instituto Técnico Privado de Saúde-Ilha da Verdade' }
          } else if (window.location.host.includes('isppluena.com')) {
            return { logo: 'logo.jpeg', descricao: 'INSTITUTO SUPERIOR POLITÉCNICO PRIVADO DO LUENA' }
          } else if (window.location.host.includes('ispatlantida.com') || window.location.host.includes('192.168.44.10')) {
            return { logo: 'logoAt.jpeg', descricao: 'INSTITUTO SUPERIOR POLITÉCNICO ATLÂNTIDA' }
          } else if (window.location.host.includes('ispamazozo.com')) {
            return { logo: 'logoMazozo.jpeg', descricao: 'INSTITUTO SUPERIOR PRIVADO-ATLÂNTIDA-MAZOZO' }
          } else if (window.location.host.includes('bendizer.net')) {
            return { logo: 'logoB.jpeg', descricao: 'INSTITUTO MÉDIO TÉCNICO PRIVADO - BENDIZER' }
          } else if (window.location.host.includes('ilhaverdade')) {
            return { logo: 'ilhaverdade.jpg', descricao: 'INSTITUTO MÉDIO TÉCNICO PRIVADO - ILHA DA VERDADE' }
          }else if(window.location.host.includes('192.168.1.254') || window.location.host.includes('localhost')){
            return { logo: 'logoEsca.png', descricao: 'Escola de Saúde Castelo'}  
         } else {
            return { logo: 'logo.jpeg', descricao: 'INSTITUTO  SUPERIOR POLITÉCNICO PRIVADO DO LUENA' }
          }
    }
    
    // Método responsável por converter o HTML gerado pelo método gerarHTML() em um arquivo PDF
    async  htmlToPDF(html, extraOptions, url) {
      console.log(url);
        try {
            await axios({
                method: 'post',
                url: url+`writefile`,
                data: {
                    html: html,
                    file_name: usuario,
                    option: extraOptions
                }
            }).then();
            this.frame(url);
        } catch (error) {
          store.state.loading_pdf = false;
        }
    }

    // Método responsável por criar a base HTML e renderizar o arquivo em outra aba
    frame(link) {
        try {
            let url = `${link}readfile/${usuario}.pdf`;

            let frame = `
            <html>
                <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}</style>
                <body>
                <iframe target="_blank" type="application/pdf" src="${url}"></iframe>
                </body>
            </html>`;
            let a = window.open('about:blank', '_blank', '');
            a.document.write(frame);
            a.document.close();
        } catch (error) {
          store.state.loading_pdf = false;
        } finally {
          store.state.loading_pdf = false;
        }
    }

    frameByName(link,nameFile) {
      try {
          let url = `${link}readfile/${nameFile}`;
          let frame = `
          <html>
              <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}</style>
              <body>
              <iframe target="_blank" type="application/pdf" src="${url}"></iframe>
              </body>
          </html>`;
          let a = window.open('about:blank', '_blank', '');
          a.document.write(frame);
          a.document.close();
      } catch (error) {
        store.state.loading_pdf = false;
      } finally {
        store.state.loading_pdf = false;
      }
  }
}
export default new impressaoUtilitario();